import { components } from '@/utils'

import render from './render'

export default {
  name: components.content,

  render
}
